import styled from 'styled-components';
import H from './H';

export default styled(H)`
  ${props => props.theme.typography.H};
`;
